import * as types from './mutation-types'
import { requestUtils, formDataFactory } from '../../helpers'

const state = {
  card: {},
  playedCards: [],
  myCards: [],
  myCardsPaging: {
    page: 1
  },
  myCard: {}
}

const getters = {
  getCard (state) {
    return state.card
  },
  getPlayedCard (state) {
    return state.playedCards
  },
  getMyCards (state) {
    return state.myCards
  },
  getMyCardsPaging (state) {
    return state.myCardsPaging
  },
  getMyCard (state) {
    return state.myCard
  }
}

const actions = {
  createCard ({ commit, rootGetters }, data) {
    let formData = formDataFactory.build(data, 'card', 'json')
    let headers = requestUtils.headersWithToken(rootGetters)
    return requestUtils.post('/cards', formData, headers)
      .then((response) => {
        if (response.success) {
          commit(types.SET_NOTIFICATION, {
            type: 'success',
            message: response.message
          })
          return response
        } else {
          throw new Error(response.message)
        }
      }).catch((error) => {
        commit(types.SET_NOTIFICATION, {
          type: 'error',
          message: error.message || error.exception || error
        })
      })
  },
  loadCard ({ commit, rootGetters }, options = {}) {
    options = Object.assign({
      playedCards: rootGetters.getPlayedCard,
      cardLevelId: rootGetters.getLevel,
      tips: rootGetters.getTips,
      userIds: rootGetters.getAllPlayers.filter(player => player.user).map((player) => player.user.id)
    }, options)
    let formData = formDataFactory.build(options, null, 'json')
    let headers = requestUtils.headersWithToken(rootGetters)
    return requestUtils.post('/cards/random', formData, headers)
      .then((response) => {
        if (response.success) {
          commit(types.SET_CARD, response.data)
          return response
        } else {
          throw new Error(response.message)
        }
      }).catch((error) => {
        commit(types.SET_NOTIFICATION, {
          type: 'error',
          message: error.message || error.exception || error
        })
      })
  },
  cardVote ({ commit, rootGetters }, vote) {
    let formData = { vote }
    let headers = requestUtils.headersWithToken(rootGetters)
    return requestUtils.put(`/cards/${rootGetters.getCard.id}/vote`, formData, headers)
      .then((response) => {
        if (response.success) {
          return response
        } else {
          throw new Error(response.message)
        }
      }).catch((error) => {
        commit(types.SET_NOTIFICATION, {
          type: 'error',
          message: error.message || error.exception || error
        })
      })
  },
  loadMyCards ({ commit, state, rootGetters }, params) {
    params = {
      page: state.myCardsPaging.page,
      ...params
    }
    let headers = requestUtils.headersWithToken(rootGetters)
    return requestUtils.get('/cards', { params }, headers)
      .then((response) => {
        if (response.success) {
          commit(types.SET_MY_CARDS, {
            cards: response.data,
            paging: response.paging
          })
          return response
        } else {
          throw new Error(response.message)
        }
      }).catch((error) => {
        commit(types.SET_NOTIFICATION, {
          type: 'error',
          message: error.message || error.exception || error
        })
      })
  },
  deleteCard ({ commit, rootGetters }, id) {
    let headers = requestUtils.headersWithToken(rootGetters)
    return requestUtils.delete(`/cards/${id}`, null, headers)
      .then((response) => {
        if (response.success) {
          commit(types.SET_NOTIFICATION, {
            type: 'success',
            message: response.message
          })
          return response
        } else {
          throw new Error(response.message)
        }
      }).catch((error) => {
        commit(types.SET_NOTIFICATION, {
          type: 'error',
          message: error.message || error.exception || error
        })
      })
  },
  loadMyCard ({ commit, rootGetters }, id) {
    let headers = requestUtils.headersWithToken(rootGetters)
    return requestUtils.get(`/cards/${id}`, null, headers)
      .then((response) => {
        if (response.success) {
          commit(types.SET_MY_CARD, response.data)
          return response
        } else {
          throw new Error(response.message)
        }
      }).catch((error) => {
        commit(types.SET_NOTIFICATION, {
          type: 'error',
          message: error.message || error.exception || error
        })
      })
  },
  updateMyCard ({ commit, rootGetters }, data) {
    let formData = formDataFactory.build(data, 'card', 'json')
    let headers = requestUtils.headersWithToken(rootGetters)
    return requestUtils.put(`/cards/${data.id}`, formData, headers)
      .then((response) => {
        if (response.success) {
          commit(types.SET_NOTIFICATION, {
            type: 'success',
            message: response.message
          })
          commit(types.SET_MY_CARD, response.data)
          return response
        } else {
          throw new Error(response.message)
        }
      }).catch((error) => {
        commit(types.SET_NOTIFICATION, {
          type: 'error',
          message: error.message || error.exception || error
        })
      })
  }
}

const mutations = {
  [types.SET_CARD] (state, card) {
    state.playedCards.push(card.id)
    state.card = card
  },
  [types.SET_MY_CARDS] (state, { cards, paging }) {
    state.myCards = cards
    state.myCardsPaging = paging
  },
  [types.SET_MY_CARD] (state, card) {
    state.myCard = card
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/card.js